import { LoginStatuses } from '../hooks/useBookLogin';
import Logos from '../images/logos';

export enum CountryAbbrvs {
    USA = 'usa',
    CA = 'ca',
}

export enum RegionName {
    USA = 'U.S.A.',
}

export enum BookStatuses {
    Active = 'active',
    Inactive = 'inactive', // TODO: update when server variable is determined
    Unsupported = 'unsupported',
    ComingSoon = 'coming',
}

export enum UnsupportedReason {
    isSupported,
    noWeb,
    DownloadExtension,
    MobileOnly,
    iOS,
    Android,
    MobileVersion,
    Maintainence,
    ComingSoon,
    UserAccountInactive
}

export enum Statuses {
    ACTIVE = 'active',
}

export type TBookAbbrvs = keyof typeof Logos.light;

export interface IRegion {
    abbr: string;
    name: string;
    isCountry: boolean;
    id: string;
    status: Statuses;
}

export interface IBookLight {
    id: string;
    name: string;
    abbr: TBookAbbrvs;
}

export interface IBookRegionLight {
    id: string;
    name: string;
    abbr: string;
}

export interface IGlobalBetsAccount {
    id: string;
    bettor: string;
    book: IBookLight;
    bookRegion: IBookRegionLight;
}

export interface IBook {
    abbr: TBookAbbrvs; // abbr of books
    id: string;
    name: string;
    rank: number;
    status: BookStatuses;
    url: string;
    sdkRequired: boolean;
    refreshCadenceActive: boolean;
    deepLinkExtension: string | null;
    deepLinkMobile: string | null;
}

interface IBookRegion extends Omit<IBook, 'url' | 'abbr'> {
    book: string;
    isCountry: boolean;
    abbr: string; // TODO: type from state constants
    status: BookStatuses;
    bonus: number | null;
    url: string | null;
}

//didn't want to mess w the existing interface so made a new one
export interface IBookRegionExtended extends Omit<IBook, 'url' | 'abbr'> {
    book: IBook;
    url: string | null;
    isCountry: boolean;
    abbr: string; // TODO: type from state constants
    status: BookStatuses;
    bonus: number | null;
}

export interface IUserAccountRegion {
    id: string;
    active: boolean;
    affiliateLink: string | null;
    promoText: string | null;
    bookRegion: IBookRegion;
}

export interface IUserAccount {
    id: string;
    user: number;
    active: boolean;
    affiliateLink: string | null;
    promoText: string | null;
    book: IBook;
    userAccountRegions: IUserAccountRegion[];
}

export interface ISelectOption {
    label: string;
    value: string;
}

export interface ITokens {
    public: string;
}

export interface IUser {
    auth0Id: string | null;
    cancelDate: string | null; // could this also be a date?
    email: string;
    id: number;
    live: boolean;
    logoUrl: string;
    manualRefresh: boolean;
    name: string;
    refreshRate: null | number; // unsure about this
    sandboxUser: null | any; // unsure
    stripeId: string | null;
    tokens: ITokens;
    isSandbox: boolean;
    managementSession: boolean;
    backButton: boolean;
    mobilePackage: boolean;
    uiMode: string;
    primaryColor: string;
    secondaryColor: string;
}

export interface IUrlData {
    id: string;
    book: string;
    eventId: string | null;
    selectionId: string | null;
    marketId: string | null;
    genericUrlFields: string | null;
}

export interface IUseGetContextResData {
    loading: boolean;
    cid: string;
    auth: string | null;
    extensionAuthToken: string | null;
    extensionVersion: string | null;
    service: string | null;
    type: string | null;
    internalId: string;
    logoUrl: string | null;
    redirectUrl: string | null;
    status: LoginStatuses | null; // Todo: this is an enum
    action: string | null;
    token: string;
    user: IUser;
    affiliateLinks: {
        [key in TBookAbbrvs]: {
            [key: string]: null;
        };
    };
    book: {
        id: string;
        name: string;
        abbr: string;
        url: string;
    };
    sdkSupport: any; //temp - want to narrow this object down more
    bettorAccount: string | null;
    urlMetadata: IUrlData[];
    userAccounts: IUserAccount[];
    globalBetsAccounts: IGlobalBetsAccount[];
    bettorAccounts: IBettorAccount[];
    otp: string | null;
    uiMode: string;
    primaryColor: string;
    secondaryColor: string;
    isBestPrice: boolean | null;
}

export interface IBettorAccount {
    id: string;
    book: IBook; // logo, enum
    verified: boolean;
    paused: boolean;
    balance: number;
    latestRefreshResponse: {
        timeCreated: string;
        id: string;
        status: number;
        detail?: string | null;
        requestId: string;
    };
    isUnverifiable: boolean;
    bookRegion: IBookRegion;
    refreshInProgress: boolean;
    TFA: boolean;
}

export interface IBestPrice {
    handle: number;
    unitSize: number;
    netProfit: number;
    winPercentage: number;
    totalAccounts: number;
    totalSlips: number;
    missedValue: {
        [Key in keyof TBookAbbrvs]: {
            missedValueEstimate: number;
            missedValueParlay: number;
        };
    };
}

export interface INetProfit {
    id: string;
    bettor: string;
    book: IBook;
    bookRegion: {
        id: string;
        name: string;
        abbr: string;
        status: string;
        country: string;
        mobileOnly: boolean;
        sdkRequired: boolean;
    };
    verified: boolean;
    access: boolean;
    paused: boolean;
    betRefreshRequested: string;
    latestRefreshResponse: {
        id: string;
        timeCreated: string;
        status: number;
        detail: null | string;
        requestId: string;
        type: string;
    };
    latestRefreshRequestId: string;
    balance: number;
    timeCreated: string;
    missingBets: number;
    isUnverifiable: boolean;
    deviceId: null | string | number;
    timeUnverified: null | string;
    TFA: boolean;
    refreshInProgress: boolean;
    metadata: {
        handle: number;
        unitSize: number;
        netProfit: number;
        winPercentage: number;
        walletShare: number;
    };
}

export interface IBookWithValues {
    id: string;
    name: string;
    abbr: string;
    missedValueEstimate: number;
    missedValueParlay: number;
    bonus: number;
    url: string;
}
